import { Toast, ToastBody, ToastHeader } from "reactstrap"



type ToasterProps = {
  type: "success" | "error" | "warning" | "info";
  message: string| null;
  icon: "success" | "error" | "warning" | "info";
};

export const ToasterAdviser = (props:ToasterProps) => {

  return (
    <Toast >
      <ToastHeader icon={props.icon}>
        {props.type === "success" && <span className="text-success">Sucesso</span>}
        {props.type === "error" && <span className="text-danger">Erro</span>}
        {props.type === "warning" && <span className="text-warning">Atenção</span>}
        {props.type === "info" && <span className="text-info">Informação</span>}
      </ToastHeader>
      <ToastBody>
        {props.icon === "success" && <span className="text-success">✔️ {props.message}</span>}
        {props.icon === "error" && <span className="text-danger">❌ {props.message}</span>}
        {props.icon === "warning" && <span className="text-warning">⚠️ {props.message}</span>}
        {props.icon === "info" && <span className="text-info">ℹ️ {props.message}</span>}
      </ToastBody>
    </Toast>
  )
}